<div [(ngpTabsetValue)]="selectedTab" ngpTabset class="flex flex-col">
  <div ngpTabList class="flex w-full items-center gap-8">
    @for (tab of tabs() | keyvalue; track tab.key) {
    <button
      ngpTabButton
      [ngpTabButtonValue]="tab.key"
      [class]="
        tab.key === selectedTab()
          ? 'button--style-primary-bordered-2 button--style-primary'
          : 'button--style-white-04'
      "
      class="button h-32 padding-x-12 rounded-4"
    >
      {{ tab.value.title }}
    </button>
    }
  </div>

  <div ngpTabPanel [ngpTabPanelValue]="selectedTab()">
    @if (storeResource.isLoading()) {
    <svg-icon
      class="absolute-center flex items-center justify-center s-14"
      src="assets/icons/ui/loading.svg"
      svgClass="loading-animation"
    ></svg-icon>
    } @else if (storeResource.error()) {
    <div
      animate.enter="animate-fade-in"
      style="text-align: center"
      class="flex flex-col gap-4 items-center justify-center w-full h-full"
    >
      {{ storeResource.error() }}
      <button
        class="button button--style-primary h-32 padding-x-12 rounded-4"
        (click)="storeResource.reload()"
      >
        Reload
      </button>
    </div>
    } @else if (storeResource.hasValue()) { @switch (selectedTab()) { @case
    ('Mines') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['Mines']"
      [columns]="userHistoryService.minesColumns()"
      [(pagination)]="pagination"
    />
    } @case ('King') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['King']"
      [columns]="userHistoryService.kingColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Tower') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['Tower']"
      [columns]="userHistoryService.towersColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Jackpot') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['Jackpot']"
      [columns]="userHistoryService.jackpotsColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Wheel') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['Wheel']"
      [columns]="userHistoryService.wheelColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Coinflip') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['Coinflip']"
      [columns]="userHistoryService.coinflipsColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Plinko') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['Plinko']"
      [columns]="userHistoryService.plinkoColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Upgrade') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['Upgrade']"
      [columns]="userHistoryService.upgradeColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Cases') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['Cases']"
      [columns]="userHistoryService.casesColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Case Battles') {
    <app-table
      animate.enter="animate-fade-in"
      [data]="store()['Case Battles']"
      [columns]="userHistoryService.caseBattlesColumns()"
      [(pagination)]="pagination"
    />
    } @default {
    <div
      animate.enter="animate-fade-in"
      style="text-align: center"
      class="flex flex-col gap-4 items-center justify-center w-full h-full"
    >
      Something went wrong, please try again.
      <button
        class="button button--style-primary h-32 padding-x-12 rounded-4"
        (click)="storeResource.reload()"
      >
        Reload
      </button>
    </div>
    } } }
  </div>
</div>
